import {inject, Injectable} from '@angular/core';
import {TodoQueryService} from './todo-query.service';
import {TodoCommandService} from './todo-command.service';

@Injectable()
export class TodoStoreService {

  private readonly queries = inject(TodoQueryService);
  private readonly commands = inject(TodoCommandService);

  // Query state
  filterParams = this.queries.filterParams;
  selectedTodoId = this.queries.selectedTodoId;
  selectedTodo = this.queries.selectedTodo;
  isLoadingSelectedTodo = this.queries.isLoadingSelectedTodo;
  todos = this.queries.todos;
  isLoading = this.queries.isLoading;
  statuses = this.queries.statuses;
  statusSummaries = this.queries.statusSummaries;
  isLoadingStatusSummaries = this.queries.isLoadingStatusSummaries;

  // Mutations
  createTodoMutation = this.commands.createTodoMutation;
  updateTodoMutation = this.commands.updateTodoMutation;
  createTodoStatusMutation = this.commands.createTodoStatusMutation;
  deleteTodoStatusMutation = this.commands.deleteTodoStatusMutation;
  updateTodoStatusMutation = this.commands.updateTodoStatusMutation;
  reorderTodoStatusesMutation = this.commands.reorderTodoStatusesMutation;
  changeTodoStatusMutation = this.commands.changeTodoStatusMutation;
  changeTodoCompletionMutation = this.commands.changeTodoCompletionMutation;
  deleteTodoMutation = this.commands.deleteTodoMutation;
  uploadTodoDocumentMutation = this.commands.uploadTodoDocumentMutation;
  deleteTodoDocumentMutation = this.commands.deleteTodoDocumentMutation;
  
  saveTodo = this.commands.saveTodo.bind(this.commands);
}
